<template>

<div>
	<template v-if="list.length == 0">
	<div class="empty-list">
		This list is empty
	</div>
	</template>

	<template v-else>
	<table class="data-list log-book-entries" cellpadding="0" cellspacing="0">
		<thead>
			<tr>
				<th v-if="showStatusBanner"></th>
				<th class="clickable" v-for="(column, index) in definition" v-if="$noId(column.column_name)" :key="index" :align="column.align" style="white-space: nowrap; padding-right: 6px;" @click="setSortBy(column.column_name)">
					<div v-if="filters.has_sales_info && column.column_name.indexOf('disposal') > -1">
						{{ column.column_name.replace('disposal_', 'sold ').capitalizeWords() }} 
						<i class="fa-solid fa-sort" style="color: #666;"></i>
					</div>
					<div v-else>
						{{ column.label }} 
						<i v-if="filters.sort_by == column.column_name" :class="['fa-solid', filters.sort_order == 'asc' ? 'fa-caret-down' : 'fa-caret-up']"></i>
						<i v-else class="fa-solid fa-sort" style="color: #666;"></i>
					</div>
				</th>
				<th></th>
			</tr>
		</thead>
		<tr :class="['clickable-list-item', { disposed: item.is_disposed }]" v-for="(item, index) in list" @click="itemClicked(item[definition[0].column_name])" :key="index">
			<td v-if="showStatusBanner" style="position: relative; padding: 0 27px 0 0;">
				<div v-if="item.moved_to_ffl_log_book_entry_id" class="logbook-list-moved"><label>Moved</label></div>
				<div v-else-if="item.is_disposed" class="logbook-list-disposed"><label>Disposed</label></div>
				<div v-else-if="!item.product_id" class="logbook-list-not-inventory"><label>On Hand, Not Inventory</label></div>
				<div v-else-if="item.disposal_full_name" class="logbook-list-has-sale-info"><label>On Hand, Has Sale Info</label></div>
				<div v-else class="logbook-list-not-disposed"><label>On Hand</label></div>
			</td>
			<td v-for="(column, index) in definition" v-if="$noId(column.column_name)" :key="index" :align="column.align" style="padding-right: 6px;">
				<span v-if="!filters.has_sales_info && column.column_name.indexOf('disposal_') > -1 && item[column.column_name] && !item.is_disposed"></span>
				<span v-else>{{ item[column.column_name] }}</span>
			</td>
			<td class="links logbooks-list-links">
				<i v-if="showAuditRemove" :class="['fas pointer fa-times link', localLoading ? 'fa-spin' : '' ]" @click.stop="auditRemove(item.ffl_log_book_entry_id)"></i>
				<i v-else-if="item.moved_to_ffl_log_book_entry_id" class="fas fa-arrow-right link-persist pointer"></i>
				<i v-else-if="item.is_disposed" class="fas fa-lock link-persist pointer" title="This item is disposed."></i>
				<i v-else-if="!item.product_id" class="fas fa-box link-persist pointer" title="This item is on hand, but not in inventory."></i>
			</td>
		</tr>
		<tr v-if="totals" class="list">
			<td v-for="(column, index) in definition" v-if="$noId(column.column_name)" :key="index" :align="column.align">
				<b>{{ totals[column.column_name] }}</b>
			</td>
			<td></td>
		</tr>
	</table>

	</template>
</div>

</template>

<script>
export default {
	name: 'list-component',
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		definition: {
			type: Array,
			required: true
		},
		list: {
			type: Array,
			required: true
		},
		showAuditRemove: {
			type: Boolean,
			required: false,
			default: false
		},
		totals: {
			type: Object,
			required: false
		},
		link: { // if list item is to be rendered as a router link
			type: String,
			required: false,
			default: ''
		},
		filters: {
			type: Object,
			required: false,
			default: {}
		},
		showStatusBanner: {
			type: Boolean,
			default: true
		}
	},
	data () {
		return {
			localLoading: false
		}
	},
	created() {
		this.localLoading = this.loading
	},
	watch: {
		loading(newVal) {
			this.localLoading = newVal
		}
	},
	methods: {
		itemClicked(itemId) {
			if (this.link == '') {
				this.$emit('clicked',itemId)
			} else {
				this.$router.push(this.link + itemId)
			}
		},
		auditRemove(fflLogBookEntryId) {
			this.$emit('auditRemove', fflLogBookEntryId)
		},
		setSortBy(which) {
			if (this.filters.sort_by != which) {
				this.filters.sort_by = which
				if (this.filters.sort_by == 'manufacturer_importer') {
					this.filters.sort_by = 'manufacturer'
					this.filters.sort_order = this.filters.sort_order == 'asc' ? 'desc' : 'asc'
				}
				else if (this.filters.sort_by == 'sequence_code' || this.filters.sort_by.indexOf('_date') > -1) {
					this.filters.sort_order = 'desc'
				} else {
					this.filters.sort_order = 'desc'
				}
			} else {
				this.filters.sort_order = this.filters.sort_order == 'asc' ? 'desc' : 'asc'
			}
			this.filters.page = 1
			this.$emit('refreshList')
		}
	}
}
</script>

<style lang="scss" scoped>
	.log-book-entries {
		td:nth-child(2) { width: 7em; } // sequence number
		td:nth-child(4) { width: 10em; padding: 0 0.25em 0 0; } // model
		td:nth-child(5) { width: 10em; padding: 0 0.25em 0 0; } // manufacturer importer
		td:nth-child(7) { width: 12em; padding: 0 0.25em 0 0; } // received from
		td:nth-child(9) { width: 12em; padding: 0 0.25em 0 0; } // disposed to
	}
	.logbook-list-disposed, .logbook-list-has-sale-info, .logbook-list-not-inventory, .logbook-list-not-disposed, .logbook-list-moved {
		position: absolute;
		top: 0; left: 0;
		width: 18px;
		height: 100%;
		label { display: none; }
	}
	.logbook-list-not-inventory {
		background-color: blue;
	}
	.logbook-list-not-inventory:hover {
		width: 210px;
		label { display: block; color: white; padding: 0.75em 0.5em 0 1em; }
	}
	.logbook-list-moved {
		background-color: #f4f4f4;
		border-right: 1px solid #ddd;
	}
	.logbook-list-moved:hover {
		width: 110px;
		label { display: block; color: #333; padding: 0.75em 0.5em 0 1em; }
	}
	.logbook-list-disposed {
		background-color: grey;
	}
	.logbook-list-disposed:hover {
		width: 110px;
		label { display: block; color: white; padding: 0.75em 0.5em 0 1em; }
	}
	.logbook-list-has-sale-info {
		background-color: #F5B041;
	}
	.logbook-list-has-sale-info:hover {
		width: 210px;
		label { display: block; color: white; padding: 0.75em 0.5em 0 1em; }
	}
	.logbook-list-not-disposed {
		background-color: green;
	}
	.logbook-list-not-disposed:hover {
		width: 110px;
		label { display: block; color: white; padding: 0.75em 0.5em 0 1em; }
	}
</style>
